import { Injectable } from '@angular/core';

import { Observable, catchError, finalize, map, of } from 'rxjs';

import { CmsService } from '../../../core/services/cms/cms.service';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import {
    DEFAULT_TEAM_COLOURS,
    GA_CONSTANTS,
    ITeamsExist,
    IfeaturedBybWidget,
    assetManagements,
} from '../components/featured-byb-widget/featured-byb-widget.model';

@Injectable()
export class FeaturedBybWidgetService {
    imagesExistOnHomeAway: ITeamsExist | Object = {};
    teamsColors: any;
    private teamsColorObservable: Observable<assetManagements[]> | null;
    teamNames: string[] = [];

    constructor(
        private gtmService: GtmService,
        private cmsService: CmsService,
    ) {}

    /**
     * formatModuleData based on sport type selected
     * @param module
     * @param moduleId
     * @returns
     */
    formatModuleData(module: IfeaturedBybWidget, moduleId?: string): IfeaturedBybWidget['data'] {
        const formatedModuleData: any = [];

        module &&
            module.data &&
            module.data.forEach((data) => {
                if (moduleId) {
                    data.event.teamNames = this.validateTeam(data.event.name);
                } else {
                    data.teamNames = this.validateTeam(data.name);
                }
                if (moduleId && data.locations && data.locations.includes(moduleId)) {
                    formatedModuleData.push({ ...data.event });
                }
            });
        return moduleId ? formatedModuleData : module.data;
    }

    /**
     * check the eventname with v or vs
     * @param event
     * @returns
     */
    validateTeam(eventName: string): string[] {
        const teamNames = eventName.toLowerCase().split(/\s+(?:v|vs)\s+/);
        this.teamNames.push(...teamNames);
        return teamNames;
    }

    /**
     * get team flags from cms asssetmanagement
     * @param teamNames
     * @returns
     */
    getTeamColorsCMS(teamNames: string[]): Observable<assetManagements[]> {
        this.teamsColorObservable = this.cmsService.getTeamsColors(teamNames, 16).pipe(
            map((cmsTeams: assetManagements[]) => {
                this.teamsColors = [];
                teamNames.forEach((teamName: string) => {
                    const team = cmsTeams.find(
                        (el) =>
                            el.teamName.toUpperCase() === teamName.toUpperCase() ||
                            (el.secondaryNames && el.secondaryNames.includes(teamName.toUpperCase())),
                    );

                    if (team) {
                        const primaryColour = team.primaryColour;
                        const secondaryColour = team.secondaryColour;
                        const teamsImage = team.teamsImage;
                        if (teamsImage) {
                            (this.imagesExistOnHomeAway as any)[teamName] = {
                                filename: teamsImage.originalname,
                            };
                        }
                        this.teamsColors.push({
                            teamName: teamName,
                            secondaryNames: team.secondaryNames,
                            primaryColour: this.checkHexColor(primaryColour, DEFAULT_TEAM_COLOURS.primary),
                            secondaryColour: this.checkHexColor(secondaryColour, DEFAULT_TEAM_COLOURS.secondary),
                            teamsImage: teamsImage,
                        });
                    }
                });
                return this.teamsColors;
            }),
            catchError((err) => {
                console.warn('Error', err);
                return of(this.teamsColors);
            }),
            finalize(() => {
                this.teamsColorObservable = null;
            }),
        );
        return this.teamsColorObservable;
    }

    private checkHexColor(color: string, defaultColor: string): string {
        const pattern = new RegExp('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$');
        return pattern.test(color) ? color : defaultColor;
    }

    /**
     * GA trackng for naviagiton of slides
     */
    gaTrackingRequest(
        locationEvent: string,
        action: string,
        urlClicked?: string,
        hrefDetails?: { positionEvent: string | number; eventDetails: string },
    ): void {
        const gtmdata = {
            event: 'Event.Tracking',
            data: {
                'component.CategoryEvent': GA_CONSTANTS.WIDGET,
                'component.LabelEvent': GA_CONSTANTS.BUILD_YOUR_BET,
                'component.ActionEvent': action,
                'component.PositionEvent': hrefDetails ? hrefDetails.positionEvent : GA_CONSTANTS.NOT_APPLICABLE,
                'component.LocationEvent': locationEvent,
                'component.EventDetails': hrefDetails ? hrefDetails.eventDetails : GA_CONSTANTS.BYB_WIDGET,
                'component.URLClicked': urlClicked ? urlClicked : GA_CONSTANTS.NOT_APPLICABLE,
            },
        };
        this.gtmService.push(gtmdata.event, gtmdata.data);
    }
}
